// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
import * as helper from './../../../../../VX/View/Assets/Js/helper';
import {initImprint} from "../../../Assets/JS/imprint_la";

require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const wrapper = helper.$('.wrapper')[0];
	const url1 = helper.getData(wrapper, 'url1');
	const url2 = helper.getData(wrapper, 'url2');
	const girls = Array.from(helper.$('.item'));
	const videos = Array.from(helper.$('.item video'));
	const steps = Array.from(helper.$('.step'));
	let currentStep = 0;
	const nextButtons = Array.from(helper.$('.next.btn'));
	const ctaButton = helper.$('#cta');
	const cta2Button = helper.$('#cta2');
	const ab1 = parseInt(helper.getData(wrapper, 'ab1'));
	let big = false;

	initImprint(helper.$('#impressumlink'), helper.$('#datenschutzlink'));

	videos.forEach((video: HTMLVideoElement) => {
		helper.addEventListener(video, 'mouseenter', () => {
			video.play();
		})
		helper.addEventListener(video, 'mouseleave', () => {
			if (big === false) {
				video.pause();
			}
		})
	})

	helper.addClickListener(ctaButton, (e:MouseEvent) => {
		e.preventDefault();
		window.open(url1, '_blank');
		window.location.href = url2;
	})

	helper.addClickListener(cta2Button, (e: MouseEvent) => {
		e.preventDefault();
		window.open(url1, '_blank');
		window.location.href = url2;
	})

	nextButtons.forEach((button) => {
		helper.addClickListener(button, (e:MouseEvent) => {
			e.preventDefault();
			helper.hide(steps[currentStep]);
			currentStep++;
			helper.show(steps[currentStep]);
		})
	})

	girls.forEach((girl) => {
		helper.addClickListener(girl, (e: MouseEvent) => {
			e.preventDefault();

			big = true;
			const me = e.currentTarget as HTMLDivElement;
			const video = me.querySelector('video');

			if (video !== undefined && video !== null) {
				video.play();
			}

			helper.hide(helper.$('.inner')[0]);
			helper.hide(me.querySelector('.bottom'));
			helper.hide(document.querySelector('.headline'));
			helper.addClass(wrapper, 'wrapper-full');

			girls.forEach((item) => {
				if (item === me) {
					helper.addClass(item, 'item-active');
				} else {
					helper.addClass(item, 'item-hidden');
				}
			})

			if (ab1 === 0) {
				helper.show(steps[0]);
			} else {
				helper.show(steps[steps.length - 1]);
			}
		});
	})
})
